<template>
  <div class="recent-activity">
    <v-toolbar
      flat
      color="white">
      <v-toolbar-title>{{ $t('serverModel.components.recentActivityTable.mostRecent','Most recently used entities') }}</v-toolbar-title>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :rows-per-page-items="[6, 12]"
      :disable-initial-sort="true">
      <template
        slot="items"
        slot-scope="{ item }">
        <td>
          <v-icon
            small
            :color="entityTypeColor(item.entityTypeName)">
            {{ entityTypeIcon(item.entityTypeName) }}
          </v-icon>
          {{ entityTypeName(item.entityTypeName) }}
        </td>
        <td>
          <a @click.stop="showEntity(item)">
            {{ item.entityLabel }}
          </a>
        </td>
        <td>{{ item.entityDescription }}</td>
        <td>
          <v-icon
            small
            :color="actionColor(item)">
            {{ actionIcon(item) }}
          </v-icon>
          {{ item.date | moment("from") }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { recentActivitySchema } from '../model'
import { actionIconMixin } from '../mixins/actionIcon'
import { entityTypeIconMixin } from '../mixins/entityTypeIcon'
import { recentActivityDataSource } from '../services'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  mixins: [actionIconMixin, entityTypeIconMixin],
  data: () => ({
    loading: false,
    headers: [
      { text: this.$t('serverModel.components.recentActivityTable.headerType', 'Type'),
        value: 'entityTypeName',
        sortable: false },
      { text: this.$t('serverModel.components.recentActivityTable.headerLabel', 'Label'),
        value: 'entityLabel',
        sortable: false },
      { text: this.$t('serverModel.components.recentActivityTable.headerDescription', 'Description'),
        value: 'entityDescription',
        sortable: false },
      { text: this.$t('serverModel.components.recentActivityTable.headerLastaction', 'Last action'),
        value: 'action',
        sortable: false }
    ],
    recentActivitySchema: recentActivitySchema
  }),
  computed: {
    ...mapGetters(['appRoute']),
    ...mapState('authentication', ['user']),
    items () {
      return this.recentActivityResponse ? this.recentActivityResponse : []
    }
  },
  asyncComputed: {
    recentActivityResponse () {
      return this.recentActivitySchema
          && this.user
          && recentActivityDataSource.summary({
            argsUrl: `user/${this.user.id}`,
            contextApi: ''
          })
    }
  },
  methods: {
    ...mapActions('schema-view', ['displayDefinition']),
    ...mapActions('notification', ['notify']),
    showEntity (item) {
      let itemReference = this.entityTypeReference(item.entityTypeName)
      if (itemReference) {
        if (itemReference.goToDefaultView) {
          itemReference.goToDefaultView(this, { id: item.entityId })
        } else if (itemReference.schema) {
          this.displayDefinition({
            schema: itemReference.schema,
            item: { id: item.entityId },
            fetch: true
          })
        }
      }
    }
  }
}
</script>

<style scoped>

  .recent-activity{
    margin-bottom: 60px;
  }

</style>
